import {
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { TIME_FRAME_OPTIONS } from "../Constants/PolicyTranslationConstants";

const AllowedTimeFrameFragment = ({
  updateRulesAfterEdit,
  editable,
  params,
  compactInputSx,
}) => {
  const [timeFrame, setTimeFrame] = useState(
    getTimeFrame(params.row?.RuleFacts?.AllowedTimeframe)
  );

  // Track input value separately for editing (so user can type freely)
  const [inputValue, setInputValue] = useState(timeFrame[0]);

  // Defensive fallback
  const allowedKeys = TIME_FRAME_OPTIONS.map((opt) => opt.key);
  const timeFrameKey = allowedKeys.includes(timeFrame[1])
    ? timeFrame[1]
    : "Days";

  // Update text input while typing, commit onBlur
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputBlur = () => {
    let newRow = structuredClone(params.row);
    let newTimeFrame = [inputValue, timeFrame[1]];
    setTimeFrame(newTimeFrame); // sync state
    newRow.RuleFacts.AllowedTimeframe = newTimeFrame.join(",");
    updateRulesAfterEdit(newRow, params.row);
  };

  const handleTimeChange = (event, index) => {
    let newRow = structuredClone(params.row);
    let newTimeFrame = timeFrame.map((val, i) =>
      i === index ? event.target.value : val
    );
    setTimeFrame(newTimeFrame);
    if (index === 1) {
      setInputValue(newTimeFrame[0]);
    }
    newRow.RuleFacts.AllowedTimeframe = newTimeFrame.join(",");
    updateRulesAfterEdit(newRow, params.row);
  };

  return (
    <div>
      <FormControl variant="outlined" fullWidth>
        <TextField
          disabled={!editable}
          sx={compactInputSx}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          slotProps={{
            input: {
              sx: { fontSize: "0.875rem" },
              endAdornment: (
                <InputAdornment position="end">
                  <Select
                    disabled={!editable}
                    onChange={(newValue) => handleTimeChange(newValue, 1)}
                    value={timeFrameKey}
                    variant="standard"
                    disableUnderline
                    sx={{ fontSize: "0.875rem", maxWidth: "75px" }}
                  >
                    {TIME_FRAME_OPTIONS.map((option) => (
                      <MenuItem
                        key={option.key}
                        value={option.key}
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </InputAdornment>
              ),
            },
          }}
        />
      </FormControl>
    </div>
  );
};

export function getTimeFrame(timeFrame) {
  if (!timeFrame) return ["", "Days"];
  // Accepts either "3,Days" or "3 Days" or "3, days", etc.
  let splitTimeFrame = timeFrame.split(/[, ]+/);
  let num = splitTimeFrame[0] || "";
  let unitRaw = splitTimeFrame[1] || "Days";

  // Normalize unit to match TIME_FRAME_OPTIONS keys
  const keyMap = {
    day: "Days",
    days: "Days",
    "day(s)": "Days",
    week: "Weeks",
    weeks: "Weeks",
    "week(s)": "Weeks",
    month: "Months",
    months: "Months",
    "month(s)": "Months",
    year: "Years",
    years: "Years",
    "year(s)": "Years",
  };

  let unitKey = keyMap[unitRaw.trim().toLowerCase()] || "Days";
  return [num, unitKey];
}

export default AllowedTimeFrameFragment;
